import "./FeelimThinkingAnimation.css";

/**
 * "Feelim is thinking" loading animation — shown while post ideas / hooks
 * are being generated (see Home.jsx handleGeneratePosts).
 */
export default function FeelimThinkingAnimation({ className = "" }) {
  return (
    <div className={`feelim-thinking-anim ${className}`.trim()} role="img" aria-label="Feelim is thinking">
      <div className="doc-lines">
        <div className="doc-line l1" style={{ "--w": "78%" }} />
        <div className="doc-line l2" style={{ "--w": "60%" }} />
        <div className="doc-line l3" style={{ "--w": "85%" }} />
        <div className="doc-line l4" style={{ "--w": "45%" }} />
        <div className="doc-line l5" style={{ "--w": "70%" }} />
        <div className="doc-line l6" style={{ "--w": "55%" }} />
        <div className="doc-line l7" style={{ "--w": "80%" }} />
        <div className="doc-line l8" style={{ "--w": "40%" }} />
      </div>

      <div className="logo-wrap">
        <svg className="feelim-mark" viewBox="0 -14 120 154" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="10" y="-8" width="100" height="116" rx="24" fill="#2DEA89" />
          <path
            d="M 22 36
               C 22 18, 38 9, 60 9
               C 82 9, 98 18, 98 36
               C 98 54, 85 64, 68 66.5
               C 66 69, 64 76, 58 82
               C 60 74, 59 69, 56 66.5
               C 34 64, 22 54, 22 36 Z"
            fill="#0a0a0a"
          />
          <circle className="eye eye-l" cx="46" cy="38" r="6.5" fill="#ffffff" />
          <circle className="eye eye-r" cx="71" cy="33" r="8.2" fill="#ffffff" />
          <rect x="10" y="96" width="100" height="34" rx="14" fill="#0a0a0a" />
          <circle className="dot dot-1" cx="38" cy="113" r="5" fill="#ffffff" />
          <circle className="dot dot-2" cx="60" cy="113" r="5" fill="#ffffff" />
          <circle className="dot dot-3" cx="82" cy="113" r="5" fill="#ffffff" />
        </svg>
      </div>
    </div>
  );
}
